// extracted by mini-css-extract-plugin
module.exports = {"navbarHeight":"70px","container":"styles_container__3nuJs","buttonAddCard":"styles_buttonAddCard__3URIY","loadingContainer":"styles_loadingContainer__3UoN-"};